import React, { useState } from 'react';
import { Box, Typography, Button, Avatar } from '@mui/material';
import { EllipsisIcon } from '../../components/GamifyIcon';
import DealOptionsMenu from './DealOptionsMenu';

export default function DealCard({ props }) {
  const {
    fullName,
    dealStage,
    attrs,
    ourDeal,
    ownerProfilePicture,
    initials,
    assigneeName,
    updatedAt,
    setAddDealOpen,
    setSortOpen,
    setSelectedDealOptionsOpen,
    getData,
    userId,
    searchStage,
    dealTypesCategoryIdMap,
    dealFilter,
    categoryId,
    searchString,
    fromDealPage,
    setIsLoaded,
  } = props;
  const [dealOptionsOpen, setDealOptionsOpen] = useState(false);

  // console.log('DealCard dealStage: ', dealStage);
  // console.log('DealCard ourDeal: ', ourDeal);
  // console.log(
  //   'DealCard getData and args for reset on deal delete: ',
  //   getData,
  //   userId,
  //   searchStage,
  //   dealTypesCategoryIdMap,
  //   dealFilter,
  //   categoryId,
  //   searchString,
  //   fromDealPage,
  //   setIsLoaded
  // );

  const handleDealOptionsClick = () => {
    setAddDealOpen(false);
    setSortOpen(false);
    setDealOptionsOpen(!dealOptionsOpen);
    setSelectedDealOptionsOpen(false);
  };

  const handleClickOffDealOptionMenu = () => {
    setDealOptionsOpen(false);
  };

  return (
    <>
      {dealOptionsOpen && (
        <Box
          onClick={handleClickOffDealOptionMenu}
          className="option-menu-container-background"
        ></Box>
      )}
      <Box className={'deal-card-container'}>
        <Box>
          <Box className={'deal-card-name-stage-section'}>
            <Typography className={'deal-card-full-name-text'}>
              {fullName}
            </Typography>
            <Box className={'deal-card-name-stage-section-right'}>
              <Typography className={'deal-card-stage-text'}>
                {dealStage}
              </Typography>
              <Button
                disableRipple={true}
                onClick={handleDealOptionsClick}
                className={'ellipsis-button'}
              >
                <EllipsisIcon></EllipsisIcon>
              </Button>
              {dealOptionsOpen && (
                <DealOptionsMenu
                  props={{
                    getData,
                    userId,
                    searchStage,
                    dealTypesCategoryIdMap,
                    dealFilter,
                    categoryId,
                    searchString,
                    fromDealPage,
                    setIsLoaded,
                    ourDeal,
                  }}
                ></DealOptionsMenu>
              )}
            </Box>
          </Box>
          {attrs.length > 0 ? (
            attrs.map((attr, i) => (
              <Box key={i}>
                <Typography className={'deal-card-attribute-text'}>
                  {attr}
                </Typography>
              </Box>
            ))
          ) : (
            <Typography className={'deal-card-attribute-text'}>
              {ourDeal.name}
            </Typography>
          )}
        </Box>
        <Box className={'deal-card-owner-section'}>
          <Box className={'deal-card-owner-section-left'}>
            {ownerProfilePicture ? (
              <Avatar
                className={'deal-card-owner-profile-picture'}
                src={ownerProfilePicture}
              />
            ) : (
              <Avatar className={'deal-card-owner-profile-picture'}>
                {initials}
              </Avatar>
            )}
            <Typography className={'deal-card-owner-text'}>
              {assigneeName}
              {/* {ourDeal.assigneeName} */}
            </Typography>
          </Box>
          <Box className={'deal-card-owner-section-right'}>
            <Typography className="deal-card-updated-at-text">
              {updatedAt}
            </Typography>
          </Box>
        </Box>
      </Box>
    </>
  );
}
